<script setup>
import {useStore} from "vuex";
import {computed} from "vue";
import DiffTag from "@/components/global-themed/DiffTag.vue";

const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
  name: {
    type: String,
    required: true,
  }
})

const store = useStore();

const firstValue = computed(() => store.getters['competitionV2/history'][0][props.name] ?? undefined)
</script>

<template>
  <DiffTag
    :value="firstValue"
    :compare="value"
  />
</template>
